// HeroSection.js
import { useState, useContext } from 'react';
import { CategoryContext } from '../CategoryContext';
import { LocationsContext } from '../LocationsContext';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import './HeroSection.css';
import { Container } from 'react-bootstrap';

const HeroSection = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  //const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedRegion, setSelectedRegion] = useState("");  // Track selected region
  const [searchQuery, setSearchQuery] = useState("");
  const categories = useContext(CategoryContext); // Get categories from context
  const regions = useContext(LocationsContext); // Get regions from context
  const navigate = useNavigate();

  // Filter only top-level categories (parent_id === null)
  const topCategories = categories.filter(cat => cat.parent_id === null);

  // Transform top categories into react-select options format
  const options = topCategories.map(cat => ({
    value: cat.id,
    label: cat.name
  }));

  // Transform regions into react-select options format
  const regionOptions = regions.regions.map(region => ({
    value: region,
    label: region
  }));

  const handleSearch = () => {
    // Construct the query string with the selected parameters
    const queryParams = new URLSearchParams();
    if (selectedCategory) queryParams.append('categoryId', selectedCategory);
    if (selectedRegion) queryParams.append('region', selectedRegion);
    if (searchQuery) queryParams.append('title', searchQuery);

    // Redirect to AdsPage with the query parameters
    navigate(`/oglasi?${queryParams.toString()}`);
  };

  return (
    <div className="hero-section">
      {/* Background overlay */}
      <div className="overlay"></div>

      {/* Hero content */}
      <Container>
        <div className="hero-content">
          <h1>Dobrodošli pri Bazarcu</h1>
          <p className="lead">
            Odkrijte skrite zaklade med malimi oglasi ali pa hitro in enostavno zaslužite s prodajo stvari, ki jih ne potrebujete več.
          </p>

          {/* Action Buttons */}
          <div className="d-flex justify-content-left my-3">
            <button
              className="btn btn-danger mx-3 browse-item-btn"
              onClick={() => navigate('/objavi-oglas')}
            >
              Objavi oglas
            </button>
            <button
              className="btn btn-light mx-2 post-item-btn"
              onClick={() => navigate('/oglasi')}
            >
              Brskaj po oglasih
            </button>
          </div>

          {/* Search Form */}
          <form
            className="search-form row bg-primary p-3 m-1 rounded align-items-center"
            onSubmit={(e) => {
              e.preventDefault(); // Prevent default form submission
              handleSearch();     // Call the search handler
            }}
          >
            <div className="col-md-3 mb-2 mb-md-0">
              <Select
                className="custom-react-select_region"
                classNamePrefix="custom-react-select_region"
                options={regionOptions}
                value={regionOptions.find(option => option.value === selectedRegion)}
                onChange={(selectedOption) => setSelectedRegion(selectedOption ? selectedOption.value : null)}
                placeholder="Izberi regijo"
                isLoading={regions.loading}
                isClearable
                isSearchable={false}
              />
            </div>
            <div className="col-md-3 mb-2 mb-md-0">
              <Select
                className="custom-react-select_category"
                classNamePrefix="custom-react-select_category"
                options={options}
                value={options.find(option => option.value === selectedCategory)}
                onChange={(selectedOption) => setSelectedCategory(selectedOption ? selectedOption.value : null)}
                placeholder="Izberi kategorijo"
                isLoading={categories.length === 0}
                isClearable
                isSearchable={false}
              />
            </div>
            <div className="col-md-4 mb-2 mb-md-0">
              <input
                type="text"
                className="form-control"
                placeholder="Vpiši iskalni niz"
                aria-label="Search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
            <div className="col-md-2">
              <button type="submit" className="btn btn-danger w-100 search-btn">
                Išči
              </button>
            </div>
          </form>
        </div>
      </Container>
    </div>
  );
};

export default HeroSection;